// $(document).on("click", ".new-addbtn", function(){

//     alert("clicked");

//     setTimeout(function(){
//         $('.cart-pro-form .product-card__quick-add-button').trigger('click');
//          $('.cart-pro-form .product-card__quick-add-button').addClass('new');
//     }, 3000);

// });


$(document).ready(function(){


  // Mobile menu new

$(".header-sidebar__linklist .has-child-menu").click(function(){
  $("body").addClass("child-menu-open");
  var link_title = $(this).attr('megamenu-target');
  $(".child-menu-block-main .child-menu-single").each(function(){
    var child_target = $(this).attr('data-child');
    if(link_title == child_target){
      $(this).addClass('child-active');
    }else{
      $(this).removeClass('child-active');
    }
  });
});


$(".child-menu-header").click(function(){
  $("body").removeClass("child-menu-open");
  $(".child-menu-single").hide();
});


  // subscription

 
// Wait for Seal app to load fully before binding
var sealInterval = setInterval(function() {
  if ($('.sealsubs-target-element input[data-type="one_time"]').length && $('.sealsubs-target-element input[data-type="subscription"]').length) {
    clearInterval(sealInterval);

    // Default selection: one-time purchase
    $('#selling_plan').val('');

    // ===== One Time Purchase =====
    $('#one-time').on('click', function() {
      $(this).addClass('active');
      $('#subscribe').removeClass('active');
      $('#delivery-options').hide();
      $('#selling_plan').val('');

      setTimeout(function() {
   var price_text = $('.product-info__block-item buy-buttons button span.btn-price').text();
   var price_textf = parseFloat(price_text.replace(/[^0-9\.]/g, ''));
    var fourth_price = price_textf / 4;
    var fourth_price_formatted = fourth_price.toFixed(2);
    var price_final = "$" + fourth_price_formatted;
    $(".fourth_payemnt").text(price_final);
    }, 500);

      const $sealOneTime = $('.sealsubs-target-element input[data-type="one_time"]');
      if ($sealOneTime.length) $sealOneTime.trigger('click');
    });

    // ===== Subscribe & Save =====
    $('#subscribe').on('click', function() {
      $(this).addClass('active'); 
      $('#one-time').removeClass('active');
      $('#delivery-options').slideDown();

     setTimeout(function() {
   var price_text = $('.product-info__block-item buy-buttons button span.btn-price').text();
   var price_textf = parseFloat(price_text.replace(/[^0-9\.]/g, ''));
    var fourth_price = price_textf / 4;
    var fourth_price_formatted = fourth_price.toFixed(2);
    var price_final = "$" + fourth_price_formatted;
    $(".fourth_payemnt").text(price_final);
    }, 500);

      const $sealSub = $('.sealsubs-target-element input[data-type="subscription"]');
      if ($sealSub.length) $sealSub.trigger('click');

      // Automatically select first plan
      const firstPlanId = $('#delivery-frequency option:first').val();
      if (firstPlanId) {
        $('#delivery-frequency').val(firstPlanId);
        $('#selling_plan').val(firstPlanId);

        const $sealSelect = $('.sealsubs-target-element select.sls-select');
        if ($sealSelect.length) {
          $sealSelect.val(firstPlanId).trigger('change');
          $sealSelect[0].dispatchEvent(new Event('change', { bubbles: true }));
        }

        $('.main-freq .slected-freq').text($('#delivery-frequency option:first').text());
      }
    });

    // ===== Custom dropdown select → Seal app =====
    $('#delivery-frequency').on('change', function() {
      const selectedPlanId = $(this).val();
      $('#selling_plan').val(selectedPlanId);

      const $sealSelect = $('.sealsubs-target-element select.sls-select');
      if ($sealSelect.length) {
        $sealSelect.val(selectedPlanId).trigger('change');
        $sealSelect[0].dispatchEvent(new Event('change', { bubbles: true }));
      }

      const $sealSub = $('.sealsubs-target-element input[data-type="subscription"]');
      if ($sealSub.length) $sealSub.trigger('click');

      $('.main-freq .slected-freq').text($('#delivery-frequency option:selected').text());
    });

    // ===== Seal app select → custom dropdown =====
    $(document).on('change', '.sealsubs-target-element select.sls-select', function() {
      const selectedSealPlan = $(this).val();
      if (selectedSealPlan) {
        $('#delivery-frequency').val(selectedSealPlan);
        $('#selling_plan').val(selectedSealPlan);
        $('.main-freq .slected-freq').text($('#delivery-frequency option:selected').text());
      }
    });

    // ===== Custom dropdown logic (span + ul + li) =====
    // Toggle ul on span click
    $(document).on('click', '.main-freq .slected-freq', function(e) {
      e.stopPropagation();
      $(this).siblings('ul').stop(true,true).slideToggle();
    });

    // Click li → update everything
    $(document).on('click', '.main-freq ul li', function(e) {
      $(".main-freq ul li").removeClass('active');
      $(this).addClass('active');
      e.stopPropagation();
      var selectedText = $(this).text().trim();
      var selectedPlanId = $(this).attr('value');

      var $mainFreq = $(this).closest('.main-freq');
      var $span = $mainFreq.find('.slected-freq');

      // Slide up dropdown first
      $(this).parent('ul').stop(true,true).slideUp(200, function() {
        // Update span AFTER ul is hidden
        $span.text(selectedText).css('display','block');
      });

      // Update hidden input
      $('#selling_plan').val(selectedPlanId);

      // Update Seal select box
      const $sealSelect = $('.sealsubs-target-element select.sls-select');
      if ($sealSelect.length) {
        $sealSelect.val(selectedPlanId).trigger('change');
        $sealSelect[0].dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update fourth payment
      setTimeout(function() {
        var price_text = $('.product-info__block-item.buy-buttons button span.btn-price').text();
        var price_textf = parseFloat(price_text.replace(/[^0-9\.]/g, ''));
        $(".fourth_payemnt").text("$" + (price_textf / 4).toFixed(2));
      }, 100);
    });

    // Close dropdown if click outside
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.main-freq').length) {
        $('.main-freq ul').stop(true,true).slideUp();
      }
    });

  }
}, 500);









  // Desktop-mega-menu

  
  $(".mega-menu-title summary").click(function(e){
    e.preventDefault(); // prevent native toggle
    $('body').addClass("open-menu");
    $(".footer-megamenu-overlay").addClass('menu-overlay');
    $(".footer-megamenu-overlay").show();

    const isOpen = $('body').hasClass("open-menu");
    $(".header__menu-disclosure").attr('aria-expanded', isOpen ? 'true' : 'false');
    $(".mega-menu").css("opacity", isOpen ? 1 : 0);
  });

  $(".panel__scroller .close-button").click(function(){
    $('body').removeClass("open-menu");
    if ($('body').hasClass('open-menu-inner')) {
      $('body').removeClass("open-menu-inner");
      $(".inner-mega-item .panel__wrapper").hide();
       $(".inner-mega-item").css({
              "opacity": 0,
              "visibility": "hidden"
              });
     }
    $(".footer-megamenu-overlay").removeClass('menu-overlay');
    $(".footer-megamenu-overlay").hide();
    $(".header__menu-disclosure").attr('aria-expanded', 'false');
    $(".mega-menu").css("opacity", 0);
     if ($('body').hasClass('outside-panel')) {
      $('body').removeClass("outside-panel");
    }
    setTimeout(function() {
    $('body').removeClass("outside-panel");
        }, 300);
  });
       
        $(document).mouseup(function(e){

          if($(e.target).closest('.panel-list__wrapper').length != 0) return false;
           $('body').removeClass("open-menu");
          if ($('body').hasClass('open-menu-inner')) {
             $('body').removeClass("open-menu-inner");
            $(".inner-mega-item .panel__wrapper").hide();
             $(".inner-mega-item").css({
              "opacity": 0,
              "visibility": "hidden"
              });
           }
           if ($('body').hasClass('outside-panel')) {
      $('body').removeClass("outside-panel");
    }
           $(".footer-megamenu-overlay").removeClass('menu-overlay');
          $(".footer-megamenu-overlay").show();
    $(".header__menu-disclosure").attr('aria-expanded', 'false');
    $(".mega-menu").css("opacity", 0);
        });


    $(document).mouseup(function(e){

          if($(e.target).closest('.panel__wrapper').length != 0) return false;
           $('body').removeClass("open-menu");
          if ($('body').hasClass('open-menu-inner')) {
             $('body').removeClass("open-menu-inner");
            $(".inner-mega-item .panel__wrapper").hide();
             $(".inner-mega-item").css({
              "opacity": 0,
              "visibility": "hidden"
              });
           }
       if ($('body').hasClass('outside-panel')) {
      $('body').removeClass("outside-panel");
    }
           $(".footer-megamenu-overlay").removeClass('menu-overlay');
      $(".footer-megamenu-overlay").show();
    $(".header__menu-disclosure").attr('aria-expanded', 'false');
    $(".mega-menu").css("opacity", 0);
        });
  
    

 $(".mega-item-title").click(function(){
   $('body').addClass("open-menu-inner");
  $(".inner-mega-item").css({
    "opacity": 1,
    "visibility": "visible"
  });
   var title_index = $(this).attr('data-title');
   $(".inner-mega-item .panel__wrapper").each(function(){
     var content_index = $(this).attr('data-content');
     if(title_index == content_index){
       $(this).show();
     }else{
       $(this).hide();
     }
   });
});


  if ($('body').hasClass('open-menu')) {
 var $body = $('body');
  var $panelWrapper = $('.panel-list__wrapper');
  $panelWrapper.on('mouseenter', function () {
    if ($body.hasClass('open-menu')) {
      $body.removeClass('outside-panel');
    }
  });

  $panelWrapper.on('mouseleave', function () {
    if ($body.hasClass('open-menu')) {
      $body.addClass('outside-panel');
    }
  });
  }
  


    var $body = $('body');
  var $panelWrapper = $('.panel__wrapper');

  $panelWrapper.on('mouseenter', function () {
    $body.removeClass('outside-panel');
  });

  $panelWrapper.on('mouseleave', function () {
    $body.addClass('outside-panel');
  });



  // Mobile-mega-menu Js Start 


  // To add class on body on click on hamburger icon
  
$(".hamburger-mob").click(function(){
  $('body').addClass('mobile-menu-drawer');
});

 // To hide mega menu on close icon click 
  
var shadowRoot = document.querySelector('#sidebar-menu').shadowRoot;
const close_button = shadowRoot.querySelectorAll('.contents button');
$(close_button).click(function(){
  $('body').removeClass('mobile-menu-drawer');
   if ($body.hasClass('open-mega-mob')) {
      $('body').removeClass('open-mega-mob');
     $(".main-mobile-mega-menu").hide();
     $(".header-sidebar__scroller .header-sidebar__linklist ").show();
    }
  if ($body.hasClass('open-mega-mob-inner')) {
    $('body').removeClass('open-mega-mob-inner');
  }
});

// Show child mega menu   
  
$(".mobile-mega-menu-title").click(function() {
  $('body').addClass('open-mega-mob');
  $(".header-sidebar__scroller .header-sidebar__linklist ").hide();
  var menu_title = $(this).attr('megamenu-target');
  $(".main-mobile-mega-menu").each(function(){
    var menu_content =$(this).attr('megamenu-content');
    if(menu_title == menu_content){
      $(this).show();
    }else{
      $(this).hide();
    }
  });
});

// To return from Child mega menu  

$(".return-main-megamenu").click(function(){
  $(".main-mobile-mega-menu").hide();
  $(".header-sidebar__scroller .header-sidebar__linklist ").show();
  $('body').removeClass('open-mega-mob');
});


$(".mob-mega-item-title").click(function(){
  $(".mobile-child-block").hide();
  $('body').addClass('open-mega-mob-inner');
    $(".inner-mega-item").css({
    "opacity": 1,
    "visibility": "visible"
  });
  var child_menu_title = $(this).attr('data-title');
  $(".inner-mega-item .panel__wrapper").each(function(){
     var child_content_index = $(this).attr('data-content');
     if(child_menu_title == child_content_index){
       $(this).show();
     }else{
       $(this).hide();
     }
   });
});

  // To return from Greate Child mega menu  

$(".return-child-megamenu").click(function(){
  $(".inner-mega-item .panel__wrapper").hide();
  $(".mobile-child-block").show();
  $('body').removeClass('open-mega-mob-inner');
   $(".inner-mega-item").css({
    "opacity": 0,
    "visibility": "hidden"
  });
});


  // For Ajax add to cart 

  

$(".sub-add-to-cart-btn").click(function() { 
  var $checkedOption = $(".plan-purchase-option:checked");

  var plan_id = $checkedOption.attr('data-plan-id');
  var variant_id = $checkedOption.attr('data-variant-id');

  var data = {
    id: variant_id,
    quantity: 1
  };

  // Add plan_id only if it's not blank
  if (plan_id && plan_id.trim() !== "") {
    data.selling_plan = plan_id;
  }

   $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (response) {
      window.location.href = '/cart';
    },
    error: function (xhr, status, error) {
      console.error("Add to cart failed:", error);
    }
  });
  
});




var DataVarID = $('.pack-title-block .single-title.active').attr('data-variant');
$('.sleepy-product-form__item form input.custom-checkout-btn-id').val(DataVarID);
var DataPlanID = $('.pack-title-block .single-title.active').attr('data-plan-id');
$('.sleepy-product-form__item form input.custom-checkout-btn-plan-id').val(DataPlanID);

  


  $(".pack-title-block .single-title").click(function(){
    $(".pack-title-block .single-title").removeClass('active');
    $(this).addClass('active');
    var PackIndex = $(this).attr('pack-index');
    var DataVarID = $(this).attr('data-variant');
    $('.sleepy-product-form__item form input.custom-checkout-btn-id').val(DataVarID);
    var DataPlanID = $(this).attr('data-plan-id');
    $('.sleepy-product-form__item form input.custom-checkout-btn-plan-id').val(DataPlanID);
    $(".pack-image").each(function(){
      var Image_Index = $(this).attr('data-pack-image');
      if(Image_Index == PackIndex){
        $(this).show();
      }else{
        $(this).hide();
      }
    });

    $(".pack-subscription-block").each(function(){
      var Subscrip_Index = $(this).attr('pack-subscription');
       if(Subscrip_Index == PackIndex){
        $(this).show();
      }else{
        $(this).hide();
      }
    });
    
  });

  $(".pack-onetime-purchase").click(function(){
    $(".pack-subscription-purchase").removeClass('active-plan');
    $(".pack-onetime-purchase").addClass('active-plan');
    $(".onetime-discount-pack").show();
    $(".subscription-discount-pack").hide();
    // $(".pack-sub-discount").removeClass('active-discount');
  });

    $(".pack-subscription-purchase").click(function(){
    $(".pack-onetime-purchase").removeClass('active-plan');
    $(".pack-subscription-purchase").addClass('active-plan');
    $(".onetime-discount-pack").hide();
    $(".subscription-discount-pack").show();
    $(".pack-sub-discount").addClass('active-discount');
  });

$(".pack-checkout-button").click(function (e) {
  e.preventDefault();

  var variant_id = $(".pack-title-block .active").attr("data-variant");
  var selling_plan_id = $(".pack-title-block .active").attr("data-plan-id");

  var data = {
    id: variant_id,
    quantity: 1
  };

  if ($(".pack-subscription-purchase").hasClass("active-plan")) {
    data.selling_plan = selling_plan_id;
  }

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (response) {
     window.monster_refresh(open, data)
    },
    error: function (xhr, status, error) {
      console.error("Add to cart failed:", error);
    }
  });
});

  






  
});


/*---------------Product Videos Block Script ------------------*/

$(document).on("click", ".product-video-item", function () {
  var videoLink = $(this).attr('video-link');
  
  var video = $(".meta_real_reviews_innerimage_new video");
  
  video.attr('src', videoLink);
  video[0].load();   // Reload the video
  video[0].play();   // Play the video
  
  $("body").addClass('video-popup-open');
});


$(document).on("click", ".meta_real_reviews_mainclose_new", function () {
  
  var video = $(".meta_real_reviews_innerimage_new video")[0];

  if (video) {
    video.pause();          // Stop the video
    video.currentTime = 0;  // Reset to start
    video.removeAttribute("src"); // Remove video source
    video.load();           // Reset the video element
  }

  $("body").removeClass("video-popup-open");
});

$(document).on("click", ".meta_real_reviews_innerimage_new video", function () {

  var video = this;
  var $icon = $(this).siblings(".play_icon"); // your SVG wrapper class

  if (video.paused) {
    video.play();
    $icon.hide();   // hide icon when playing
  } else {
    video.pause();
    $icon.show();   // show icon when paused
  }

});


$(document).on("click", ".mute_video_popup", function () {

  var video = $(".meta_real_reviews_innerimage_new video")[0];

  if (video) {
    video.muted = true; // Mute video
  }

  $(".mute_video_popup").hide();
  $(".unmute_video_popup").show();
});


$(document).on("click", ".unmute_video_popup", function () {

  var video = $(".meta_real_reviews_innerimage_new video")[0];

  if (video) {
    video.muted = false; // Unmute video
  }

  $(".unmute_video_popup").hide();
  $(".mute_video_popup").show();
});





 $('body').click(function(e) {
      if (!$(e.target).closest('.meta_real_reviews_innerpopup_new').length){
  
      var video = $(".meta_real_reviews_innerimage_new video")[0];

      if (video) {
        video.pause();
        video.currentTime = 0;
        video.removeAttribute("src");
        video.load();
      }
      $("body").removeClass("video-popup-open");
        
      }
  });





$('.copy-code-block').on('click', function () {
    var code = $(this).attr('data-code');
    // Create a temporary input to copy
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(code).select();
    document.execCommand("copy");
    $temp.remove();
    alert("Code copied: " + code);
  });

// add to cart wraper
document.addEventListener("DOMContentLoaded", function() {
  // dono blocks select karo
  const quantityBlock = document.querySelector('[data-block-id="quantity_selector_Kg9hwG"]');
  const buyBlock = document.querySelector('[data-block-id="buy_buttons"]');

  if (quantityBlock && buyBlock) {
    // wrapper create karo
    const wrapper = document.createElement("div");
    wrapper.classList.add("product-info__wrapper"); // apni custom class

    // quantity block ke upar insert karo
    quantityBlock.parentNode.insertBefore(wrapper, quantityBlock);

    // dono blocks wrapper ke andar move karo
    wrapper.appendChild(quantityBlock);
    wrapper.appendChild(buyBlock);
  }
});


// first accordion to open
  document.addEventListener("DOMContentLoaded", function () {
    // Select the first accordion details
    const firstAccordion = document.querySelector(
      ".accordion-group .accordion__disclosure"
    );

    if (firstAccordion) {
      firstAccordion.setAttribute("open", "");
      firstAccordion.setAttribute("aria-expanded", "true");
    }
  });

    document.addEventListener("DOMContentLoaded", function () {
    // Select the inventory and review elements
    const reviews = document.querySelector(
      '.product-info__block-item[data-block-type="@app"]'
    );
    const inventory = document.querySelector(
      '.product-info__block-item[data-block-type="inventory"]'
    );

    if (reviews && inventory) {
      // Create wrapper div
      const wrapper = document.createElement("div");
      wrapper.classList.add("product-meta-wrapper");

      // Insert wrapper before reviews
      reviews.parentNode.insertBefore(wrapper, reviews);

      // Move both reviews and inventory inside wrapper
      wrapper.appendChild(reviews);
      wrapper.appendChild(inventory);
    }
  });









$(document).on("click", ".sls-purchase-options-container .sls-option-container", function () {
    var price = $(this).find('.sls-selling-plan-group-first-line .sls-price span').text();
    $('.product-info__block-item buy-buttons button span.btn-price').text(price);
  });

  
$(document).on("click", ".block-swatch ", function () {
  setTimeout(function() {
   var price_text = $('.product-info__block-item buy-buttons button span.btn-price').text();
   var price_textf = parseFloat(price_text.replace(/[^0-9\.]/g, ''));
    var fourth_price = price_textf / 4;
    var fourth_price_formatted = fourth_price.toFixed(2);
    var price_final = "$" + fourth_price_formatted;
    $(".fourth_payemnt").text(price_final);
    }, 500);
});